import { TimeSlot } from '@hydrodigital/design-system';

export interface AlertSchedule {
	day: number;
	startTime: number;
	endTime: number;
}

export function timeSlotsToAlertSchedule(slots: TimeSlot[]): AlertSchedule[] {
	if (!slots || slots.length === 0) return [];

	const slotsByDay: Record<number, number[]> = {};
	slots.forEach((slot) => {
		if (!slotsByDay[slot.day]) {
			slotsByDay[slot.day] = [];
		}
		slotsByDay[slot.day].push(slot.hour);
	});

	const result: AlertSchedule[] = [];

	Object.entries(slotsByDay).forEach(([dayStr, hours]) => {
		const day = parseInt(dayStr);

		const sortedHours = [...hours].sort((a, b) => a - b);

		let rangeStart = sortedHours[0];
		let rangeEnd = sortedHours[0];

		for (let i = 1; i < sortedHours.length; i++) {
			if (sortedHours[i] === rangeEnd + 1) {
				rangeEnd = sortedHours[i];
			} else {
				result.push({ day, startTime: rangeStart, endTime: rangeEnd + 1 });
				rangeStart = sortedHours[i];
				rangeEnd = sortedHours[i];
			}
		}

		result.push({ day, startTime: rangeStart, endTime: rangeEnd + 1 });
	});

	return result.sort((a, b) => a.day - b.day || a.startTime - b.startTime);
}

export function alertScheduleToTimeSlots(schedules: AlertSchedule[]): TimeSlot[] {
	if (!schedules || schedules.length === 0) return [];

	const slots: TimeSlot[] = [];

	schedules.forEach((schedule) => {
		for (let hour = schedule.startTime; hour < schedule.endTime; hour++) {
			slots.push({ day: schedule.day, hour });
		}
	});

	return slots.sort((a, b) => a.day - b.day || a.hour - b.hour);
}
